// extracted by mini-css-extract-plugin
module.exports = {"example":"SideMenu_example__Z3eHu","MenuWrapper":"SideMenu_MenuWrapper__Xep01"};